import { makeObservable } from 'mobx';
import { AssureAdminApiClientStore } from './assure-admin-api-client.store';
import { FileTransfersApiClient } from '../api';
import { AssureBaseStore, IAssureStoreConstructorOptions } from './assure-base.store';
import { FileTransferDto, ICreateFileTransferRequest, TUpdateFileTransferRequest } from 'dto/file-transfer.dto';

export type IFileTransfersStoreConstructorOptions = IAssureStoreConstructorOptions;

export class FileTransfersStore extends AssureBaseStore<FileTransfersApiClient, any> {

    private readonly _apiClientStore: AssureAdminApiClientStore;

    public constructor(
        options: IFileTransfersStoreConstructorOptions,
    ) {
        super(options);
        makeObservable(this);
        this._apiClientStore = options.apiClientStore;
    }

    protected get apiClient(): FileTransfersApiClient {
        return this._apiClientStore.apiClients.fileTransfers;
    }

    public async createFileTransfer(accountId: number, deviceGroupName: string, params: ICreateFileTransferRequest): Promise<FileTransferDto> {
        const response = await this.apiClient.createFileTransfer(accountId, deviceGroupName, params);
        return new FileTransferDto(response.fileTransfer);
    }

    public async updateFileTransfer(accountId: number, uuid: string, params: TUpdateFileTransferRequest): Promise<boolean> {
        const response = await this.apiClient.updateFileTransfer(accountId, uuid, params);
        return response?.updated;
    }

    public async getFileTransfers(accountId: number, deviceGroupName: string): Promise<FileTransferDto[]> {
        const response = await this.apiClient.getFileTransfers(accountId, deviceGroupName);
        return response.fileTransfers.map((fileTransfer: any) => new FileTransferDto(fileTransfer));
    }

    public async deleteFileTransfer(accountId: number, uuid: string): Promise<boolean> {
        const response = await this.apiClient.deleteFileTransfer(accountId, uuid);
        return response?.deleted;
    }
}
